import { useSelector } from "react-redux";
import { requiresStripeOnboarding } from "Helper/stripeConnectGuard";

const useStripeOnboardingGuard = () => {
  const onboardingStatus = useSelector(
    (state) => state.getStripeOnboardingStatusReducer
  );
  const stripeAccountStatus = useSelector(
    (state) => state.getStripeAccountStatusReducer
  );
  const stripeDashboardUrl = useSelector(
    (state) => state.getUsableCrediturlReducer
  );

  const isOnboardingRequired = requiresStripeOnboarding(
    onboardingStatus,
    stripeAccountStatus
  );

  return {
    onboardingStatus,
    stripeAccountStatus,
    stripeDashboardUrl,
    isOnboardingRequired,
  };
};

export default useStripeOnboardingGuard;
